// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2J_Hx","addWidgetButton":"Header_addWidgetButton__-Hl28","dashboardTabs":"Header_dashboardTabs__3tgcc","active":"Header_active__29Thz"};